"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Sad;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Sad(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Emojis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "icon"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "sad"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,7.5A42.5,42.5,0,1,0,92.5,50,42.548,42.548,0,0,0,50,7.5Zm0,80A37.5,37.5,0,1,1,87.5,50,37.542,37.542,0,0,1,50,87.5Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-1",
    cx: "66.101",
    cy: "57.5",
    r: 5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M77.477,48.967c-6.931-.042-7.724-4.95-7.793-5.532a2.5,2.5,0,0,0-4.976.491c.324,3.448,3.4,9.984,12.738,10.041h.016a2.5,2.5,0,0,0,.015-5Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-1",
    cx: "33.899",
    cy: "57.5",
    r: 5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M35.292,43.926a2.5,2.5,0,1,0-4.978-.469c-.021.224-.6,5.467-7.791,5.51a2.5,2.5,0,0,0,.015,5h.016C31.888,53.91,34.968,47.374,35.292,43.926Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M64.2,70.96a24.558,24.558,0,0,0-28.4,0,2.5,2.5,0,0,0,2.89,4.08,19.559,19.559,0,0,1,22.618,0,2.5,2.5,0,0,0,2.89-4.08Z"
  }))));
}